<div class="container">
	<div class="section-title">Configuration Management</div>
	<div>
		Asset Configurations define the relationship between sensors and components, and also define the how
		information from components is used to assert knowledge about the health of the component. Asset
		Configurations can be applied to multiple assets of the same type.
	</div>

	<div class="bubble-tabs">
		<a class="bubble-tab" routerLink="manage-config" routerLinkActive="selected">Manage configs</a>
		<a class="bubble-tab" routerLink="templated-config" routerLinkActive="selected">Add templated config</a>
		<a class="bubble-tab" routerLink="add-raw-config" routerLinkActive="selected">Add raw config</a>
		<a class="bubble-tab" routerLink="thresholding" routerLinkActive="selected">Thresholding</a>
		<a class="bubble-tab" routerLink="thresholding-cross" routerLinkActive="selected">Thresholding (cross-org)</a>
		@if (api.user.role === 'master') {
		<a class="bubble-tab" routerLink="manage-templates" routerLinkActive="selected">Manage templates (MASTER)</a>
		}
	</div>
	<router-outlet></router-outlet>
</div>